<template>
    <el-autocomplete v-model="value" :fetch-suggestions="querySearchAsync" :placeholder="placeholder || '请输入内容'" @select="handleSelect" valueKey="name"></el-autocomplete>
</template>
<script>
import { getHouseSearchBaseList } from '@/service/housedict'
import { mapGetters } from 'vuex'
export default {
    name: 'AutoComplete',
    props: {
        parameter: Object,
        placeholder: String,
        callback: Function
    },
    data () {
        return {
            value: ''
        }
    },
    computed: {
        ...mapGetters([
            'permission_siteId'
        ])
    },
    methods: {
        querySearchAsync (queryString, callback) {
            if(queryString === '') {
                callback([])
                return null
            }
            const params = Object.assign({}, this.parameter, {
                site_id: this.permission_siteId,
                house_name: this.value
            })
            console.log(params)
            getHouseSearchBaseList(params).then((data) => {
                callback(data)
            }).catch(err => {
                this.$message({
                    message: err.message,
                    type: 'error',
                })
                callback([])
            })
        },
        handleSelect(item) {
            this.callback && this.callback(item)
        },
        clear () {
            this.value = ''
        }
    }
}
</script>